<template>
  <div class="main-layout">
    <div class="content-container">
      <slot></slot>
    </div>
    <BottomNavigation />
  </div>
</template>

<script>
import BottomNavigation from './BottomNavigation.vue'

export default {
  name: 'MainLayout',
  components: {
    BottomNavigation
  }
}
</script>

<style scoped>
.main-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.content-container {
  flex: 1;
  padding-bottom: 70px; /* Space for the bottom navigation */
}
</style> 